import React from 'react'
import { IconType } from 'react-icons';
import { FiFacebook, FiLinkedin, FiTwitter } from 'react-icons/fi';
import { Link } from "react-router-dom"
import Img from "./Img"

export interface Social {
    name: string;
    icon: IconType;
    link: string;
}

const socials: Social[] = [
    {
        name: "Facebook",
        icon: FiFacebook,
        link: "https://facebook.com"
    },
    {
        name: "Twitter",
        icon: FiTwitter,
        link: "https://Twitter.com"
    },
    {
        name: "LinkedIn",
        icon: FiLinkedin,
        link: "https://linkedin.com"
    }
];

const usefulLinks = [
    {
        title: "Homepage",
        link: '/'
    },
    {
        title: "Services",
        link: '/services'
    },
    {
        title: "Accomodations",
        link: '/'
    },
    {
        title: "Car Rentals",
        link: '/cars'
    },
    {
        title: "Restaurants",
        link: '/restaurants'
    },
    {
        title: "Sitemap",
        link: '/sitemap'
    }
];

const supportLinks = [
    {
        title: "FAQs",
        link: '/faq'
    },
    {
        title: "Support Center",
        link: '/support'
    },
    {
        title: "Security",
        link: '/security'
    }
];

const contact = ["+234- 70-1449-8006", "info@murwiza.rw", "23, Mukamira , Musanze-Rubavu road"]

const FooterSignedOut = () => {
    return (
        <footer className="text-white w-full bg-[#000A22] z-50 p-20 flex justify-between flex-wrap gap-8" id="footer">
            <div className="Socials flex flex-col gap-4 max-w-[400px]">
                <Img
                    src="/Murwiza_white.svg"
                    alt="White logo"
                    width={126}
                    height={20}
                />
                <p className='max-w-[200px]'>Book your next home, restaurant, car in Rwanda.</p>
                <div className="Links flex gap-5 items-center">
                    {
                        socials.map((social: Social, i: number) => {
                            return <a href={social.link} key={`Social-${i}`}>
                                <social.icon fill='white' />
                            </a>
                        })
                    }
                </div>
            </div>
            <div className="UsefulLinks">
                <h2 className='mb-4'>Useful Links</h2>
                <div className="links flex flex-col gap-3">
                    {
                        usefulLinks.map((link, i: number) => {
                            return (
                                <Link className='hoverable w-fit' to={link.link} key={`UsefulLink-${i}`}>
                                    {link.title}
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
            <div className="UsefulLinks">
                <h2 className='mb-4'>Support</h2>
                <div className="links flex flex-col gap-3">
                    {
                        supportLinks.map((link, i: number) => {
                            return (
                                <Link className='hoverable w-fit' to={link.link} key={`UsefulLink-${i}`}>
                                    {link.title}
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
            <div className="UsefulLinks">
                <h2 className='mb-4'>Contact</h2>
                <div className="links flex flex-col gap-3">
                    {
                        contact.map((link, i: number) => {
                            return (
                                <p key={`UsefulLink-${i}`}>
                                    {link}
                                </p>
                            )
                        })
                    }
                </div>
            </div>
        </footer>
    )
}

export default FooterSignedOut